import { render, staticRenderFns } from "./tips-dialog.vue?vue&type=template&id=76a2d0e0&scoped=true&"
import script from "./tips-dialog.vue?vue&type=script&lang=js&"
export * from "./tips-dialog.vue?vue&type=script&lang=js&"
import style0 from "./tips-dialog.vue?vue&type=style&index=0&id=76a2d0e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a2d0e0",
  null
  
)

export default component.exports